import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowRight } from "lucide-react";
import TrialCTA from "@/components/TrialCTA";
import Seo from "@/components/Seo";

export default function Classes() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/classes").then((r) => setItems(r.data)); }, []);
  return (
    <div>
      <Seo
        title="Classes — Kore Kombat, Blast, Zones & Ascent"
        description="Five coached small-group classes at Kore Wellbeing: boxing conditioning, core, zones circuit, hill-inspired conditioning, and a beginners' foundations programme. All included in Kore Coaching."
        path="/classes"
      />
      <section className="container-kore pt-16 pb-8 max-w-3xl">
        <span className="eyebrow">The Classes</span>
        <h1 className="display-1 text-kore-forest mt-4">Coached group classes at KORE.</h1>
        <p className="mt-6 text-lg text-kore-ink/75 leading-relaxed">Ascent, Zones, Blast and Kombat — small-group sessions, all coached and scaled to you. Included in KORE Coaching where your membership allows.</p>
      </section>
      <section className="container-kore py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {items.map((c) => (
          <Link key={c.slug} to={`/classes/${c.slug}`} data-testid={`classes-card-${c.slug}`} className="group rounded-3xl overflow-hidden bg-white border border-kore-gold/15 hover:shadow-lift transition-all duration-500">
            <div className="aspect-[4/3] overflow-hidden">
              <img src={c.image_url} alt={c.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="p-7">
              <div className="flex items-center justify-between text-[11px] uppercase tracking-[0.22em] text-kore-gold">
                <span>45–60 min</span><span>{c.difficulty}</span>
              </div>
              <h3 className="font-display text-3xl mt-3 text-kore-forest">{c.name}</h3>
              <p className="mt-2 text-sm text-kore-ink/70 font-light">{c.tagline}</p>
              <span className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-kore-forest group-hover:text-kore-gold transition">Explore <ArrowRight size={12} /></span>
            </div>
          </Link>
        ))}
      </section>
      <TrialCTA variant="inline" />
    </div>
  );
}
